import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Select, Avatar, Alert, message, Popconfirm } from "antd";
import {AndroidOutlined, ArrowRightOutlined, DeleteFilled} from '@ant-design/icons';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {useMutation, useQuery, useQueryClient} from 'react-query';
import {GetProfileConsole} from "../../../../../api/console";
import { ConsoleGetApps } from "../../../../../api/console";
import Moment from 'moment';
import 'moment/locale/ru';
import {DateBlock} from "../../../../ui/date";
import Config from "../../../../../config";
import {DeleteApp} from "../../../../../api/apps";



export const DeveloperIndexController = (props) => {
    const [ page, setPage ] = useState(0);
    const [ search, setSearch ] = useState('');
    const [ status, setStatus ] = useState('');
    const [ limit, setLimit ] = useState(10);
    const params = useParams();
    const nav = useNavigate();
    const queryClient = useQueryClient();

    const DeleteMutation = useMutation(
        (data) => DeleteApp(data.developer_id, data.app_id),
        {
            onSuccess: (data) => {
                queryClient.invalidateQueries(['app_list']);
                message.success(`Приложение успешно удалено`)
            },
            onError: (e) => {
                console.error(`[DeleteMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const Columns = [
        {
            title: 'Название',
            key: 'title',
            render: (row) => {
                let avatarProps = {
                    shape: 'square',
                    icon: <AndroidOutlined />,
                    size: 32,
                };

                if (row.media) {
                    let icon = row.media.filter(i => i.type === 'icon');
                    if (icon.length > 0) {
                        avatarProps.src = `${Config.MEDIA.IMAGES}/${icon[0].hash}/small`;
                    }
                }

                return (
                    <Link to={`/console/${row.developer}/app/${row.id}`} className={`app`}>
                        <Avatar {...avatarProps} />
                        <span className={`app_info`}>
                            <span className="app_title">{row.title}</span>
                            {row.app_id && <span className="app_id">{row.app_id}</span>}
                        </span>
                    </Link>
                );
            }
        },
        {
            title: 'Установок',
            key: 'installs_count',
            align: 'center',
            //render: (row) => 0,
            render: r => r.installs_count,
        },
        {
            title: 'Статус',
            key: 'status',
            align: 'center',
            render: r => r.status,
        },
        {
            title: 'Дата обновления',
            key: 'update_at',
            align: 'center',
            render: r => {
                return <DateBlock date={r.updatedAt} />;
            }
        },
        {
            title: '',
            key: 'actions',
            align: 'center',
            render: row => {
                return (
                    <Button.Group>
                        <Popconfirm onConfirm={() => {
                            DeleteMutation.mutate({
                                app_id: row.id,
                                developer_id: row.developer,
                            })
                        }} title={`Вы уверечены, что хотите удалить приложение?`} okText={`Да, удалить`} cancelText={`нет`}>
                            <Button
                                loading={DeleteMutation.isLoading}
                                type={`danger`}
                                icon={<DeleteFilled />}
                            />
                        </Popconfirm>
                        <Button
                            loading={DeleteMutation.isLoading}
                            icon={<ArrowRightOutlined />}
                            type={`primary`}
                            onClick={() => nav(`/console/${row.developer}/app/${row.id}`)}
                        >Открыть</Button>
                    </Button.Group>

                )
            }
        }
    ];

    const appList = useQuery(
        ['app_list', params.developer_id, search, page, limit, status],
        () => ConsoleGetApps(params.developer_id, search, page, limit, status)
    );

    const OpenCreatePage = () => {
        nav(`/console/${params.developer_id}/apps_create`)
    }

    useEffect(() => {
        queryClient.invalidateQueries(['app_list', search, page, limit, status]);
    }, [page, limit, search, status]);


    return (
        <div className={`dev__layout apps`}>
            <div className={`dev__layout--header`}>
                <div className="header__info">
                    <h1>Приложения</h1>
                    <p>Список ваших приложений и игр</p>
                </div>
            </div>
            <Alert
                className={`console--alert__default`}
                type={"info"}
                message={`Ниже представлен список ваших приложений, для продолжения работы с приложением нажмите на название приложения или кнопку "открыть"`}
            />
            <div className="dev__layout--content">
                <Table
                    title={() => {
                        return (
                            <div className={`dev__table--header`}>
                                <div className="header__column">
                                    <Button type={`primary`} onClick={OpenCreatePage}>Создать приложение</Button>
                                    <Select placeholder={`Выберите статус`} allowClear onChange={(st) => {
                                        setStatus(st);
                                    }}>
                                        <Select.Option value={"published"}>Опубликован</Select.Option>
                                        <Select.Option value={"moderated"}>На модерации</Select.Option>
                                        <Select.Option value={"unpublished"}>Не опубликован</Select.Option>
                                        <Select.Option value={"removed_store"}>Удален магазином</Select.Option>
                                        <Select.Option value={"draft"}>Черновик</Select.Option>
                                    </Select>
                                </div>
                                <div className="header__column">
                                    <Input.Search placeholder={`Название приложение или ID`} onSearch={async (search) => {
                                        await setPage(0);
                                        await setSearch(search);
                                    }}/>
                                </div>
                            </div>
                        );
                    }}
                    loading={appList.isLoading}
                    dataSource={appList.data?.list}
                    locale={{'emptyText': 'У вас еще нет приложений'}}
                    columns={Columns}
                    rowKey={(item) => item.id}
                    pagination={{
                        current: appList.data?.filter?.page || 1,
                        defaultCurrent: appList.data?.filter?.page || 1,
                        // hideOnSinglePage: true,
                        pageSize: appList.data?.filter?.limit || 1,
                        pageSizeOptions: [10, 30, 50, 100],
                        responsive: true,
                        total: appList.data?.total || 0,
                        onChange: (page, pageSize) => {
                            setPage(page)
                            setLimit(pageSize)
                        }
                    }}
                />
            </div>
        </div>
    );
}

export default DeveloperIndexController;